import styled from 'styled-components/macro';
import Form from 'components/molecules/Form';

export const SubTitle = styled.span`
  color: var(--light-gray);
  margin-bottom: 40px;
  display: block;
  @media (min-width: 768px) {
    margin-bottom: 80px;
  }
`;

export const StyledForm = styled(Form)`
  text-align: left;
  margin: 0 auto;
`;
